import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"

import ContentCaption from "../ContentCaption/ContentCaption"
import Observer from "../../../Observer/Observer"
import Wistia from "../../../Wistia/Wistia"

import IframeWrapper from "./IframeWrapper/IframeWrapper"

const VideoWrapperFIGURE = styled.figure`
  width: 100%;
  max-width: 908px;
  margin: var(--spacing--M) 0 calc(var(--spacing--M) + var(--spacing--XS));
`;

const processVideoUrl = url => {
  if (url.includes("youtube.com") && !url.includes("/embed/")) {
    const youtubeIdMatch = url.match(/(?:v=)(.+)/)
    const youtubeId = youtubeIdMatch && youtubeIdMatch[1]
    
    if (!youtubeId) {
      console.error("VIDEO ID NOT FOUND")
      return ""
    }
    
    return `https://www.youtube.com/embed/${youtubeId}`
  }
  
  return url
}

const ContentVideo = ({ ...props }) => {
  return ( 
    <Observer>
      {(ref, isObserved) => (
        <span
          ref={ref}
          style={{
            display: "block",
            minHeight: isObserved ? "0" : "300px",
          }}
        >
          {isObserved && ( 
              <VideoWrapperFIGURE>
                  {
                    props.videoId
                    ? <Wistia id={props.videoId} />
                    : <IframeWrapper 
                        src={processVideoUrl(props.videoUrl)} 
                        style={{width:"100%"}} 
                        title="Video player" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen   
                      />
                    }
                    {
                      props.caption && <ContentCaption>{props.caption}</ContentCaption>
                    }
              </VideoWrapperFIGURE>
          )}
        </span>
      )}
    </Observer>
  )
}

export const VideoFragment = graphql`
fragment VideoFragment on ContentfulContentBlockVideo {
  contentful_id
  videoTitle
  videoId
  caption
  videoUrl
}
`

export default ContentVideo
